import * as React from 'react';

import Box from '@mui/material/Box';

export default function Banner(){
    return (
        <Box className='banner'>
            <Box className='content-wrapper'>
                <Box className='content'>
                    <h1 className='title'>FINANCE MANAGEMENT ASSOCIATE PROGRAM </h1>
                    <p className='subtitle'>Navigate an Impactful Career at Sea Finance</p>
                    <p className='sub-subtitle'>A specialized path for aspiring Accounting & Finance talents</p>
                    {/* <a className='btn-apply' href="https://career.sea.com/position/J00350563" style={{minWidth: "100px"}}>APPLY NOW</a> */}
                </Box>
            </Box>
        </Box>
    );
}